import React from "react";

import PropTypes from "prop-types";

import useField from "fields/hooks/useField";

import RbCheckboxControl from "../RbCheckboxControl";

function RbField(props) {
  const { fieldName, onChangeChecked, checked: checkedProp, ...others } = props;

  const { value, setFieldValue, setFieldTouched } = useField({
    path: fieldName,
  });

  const handleChangeChecked = React.useCallback(
    (checked) => {
      setFieldValue(checked);
      setFieldTouched(true);
      if (onChangeChecked) {
        onChangeChecked(checked);
      }
    },
    [setFieldValue, setFieldTouched, onChangeChecked]
  );

  return (
    <RbCheckboxControl
      {...others}
      onChangeChecked={handleChangeChecked}
      checked={checkedProp ?? value ?? false}
    />
  );
}

RbField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  onChangeChecked: PropTypes.func,
  checked: PropTypes.bool,
};

RbField.defaultProps = {
  onChangeChecked: undefined,
  checked: undefined,
};

export default React.memo(RbField);
